const BlocklyEditor = require('./BlocklyEditor');
const Builder = require('./BuilderBase');
const Button = require('./Button');
const LiveDataList = require('./lists/LiveDataList');
const CardList = require('./lists/CardList');
const DownloadButton = require('./DownloadButton');
const HiddenFor = require('./HiddenFor');
const CustomizableVisibility = require('./CustomizableVisibility');
const ImportForm = require('./ImportForm');
const MarkRecord = require('./MarkRecord');
const PieChart = require('./PieChart');
const ReadOnlyFor = require('./ReadOnlyFor');
const ShortTextView = require('./dataViews/ShortTextView');
const DataAggregation = require('./dataViews/DataAggregation');
const FixedText = require('./dataViews/FixedText');
const SimpleDialog = require('./SimpleDialog');
const Swagger = require('./Swagger');
const TableList = require('./lists/TableList');
const Toggle = require('./actionElement/Toggle');
const MenuButton = require('./actionElement/MenuButton');
const SubForm = require('./SubForm');
const PowerSliderPopup = require('./actionElement/PowerSliderPopup');
const Href = require('./actionElement/Href');
const Menu = require('./menus/Menu');

let DetailPane;

module.exports = class Layout extends Builder {
    constructor(title, properties) {
        super('layout_LeftAlignLayout', title, properties);
    }

    blocklyEditor(title, properties) {
        let blocklyEditor = new BlocklyEditor(title, properties);
        this.addChildBlock(blocklyEditor);
        return blocklyEditor;
    }

    button(title, properties) {
        let actionElement = new Button(title, properties);
        this.addChildBlock(actionElement);
        return actionElement;
    }

    liveDataList(title, properties) {
        const list = new LiveDataList(title, properties);
        this.addChildBlock(list);
        return list;
    }

    cardList(title, properties) {
        let list = new CardList(title, properties);
        this.addChildBlock(list);
        return list;
    }

    /**
     *
     * @param {object} properties
     * @param {string} properties.title
     * @param {boolean} properties.isTabAccess
     * @param {string} properties.referenceId
     * @param {boolean} properties.readOnly
     */
    customizableVisibility(properties) {
        let modifier = new CustomizableVisibility(properties);
        this.addChildBlock(modifier, 'securityModifier');
        return this;
    }

    dataAggregation(title, properties) {
        let dataAggregation = new DataAggregation(title, properties);
        this.addChildBlock(dataAggregation);
        return dataAggregation;
    }

    detailPane(forAction, properties, options) {
        if (typeof properties === 'string') {
            throw new Error('do NOT pass in a title (first argument)');
        }
        const propertyKeys = Object.keys(properties);
        if (!forAction) {
            throw new Error('You must specify a "forAction" on the test tree Detail Pane constructor.');
        }
        if (!propertyKeys.includes('namespace') || !propertyKeys.includes('relation')) {
            throw new Error('You must specify "namespace" and "relation" properties for the Detail Pane');
        }
        // this has to be loaded here because there IS a circular dependency
        // Layout can have detail pane, which can have a singleRecordForm, which can have a layout.
        DetailPane = DetailPane || require('./DetailPane');

        const detailPane = new DetailPane('testDetailPane', {
            namespace: properties.namespace,
            relation: properties.relation,
            forAction: forAction
        });
        this.addChildBlock(detailPane, undefined, options);

        return detailPane;
    }

    dialog(title, properties) {
        let dialog = new SimpleDialog(title, properties);
        this.addChildBlock(dialog);
        return dialog;
    }

    downloadButton(title, properties) {
        let button = new DownloadButton(title, properties);
        this.addChildBlock(button);
        return button;
    }

    graph(title, properties) {
        let graph = new PieChart(title, properties);
        this.addChildBlock(graph);
        return graph;
    }

    hiddenFor(role) {
        let hiddenFor = new HiddenFor(role);
        this.addChildBlock(hiddenFor, 'securityModifier');
        return this;
    }

    href(title, properties) {
        let href = new Href(title, properties);
        this.addChildBlock(href);
        return href;
    }

    importForm(title, properties) {
        const importForm = new ImportForm(title, properties);
        this.addChildBlock(importForm);
        return importForm;
    }

    markRecord(title, properties) {
        const markRecord = new MarkRecord(title, properties);
        this.addChildBlock(markRecord);
        return markRecord;
    }

    menu(title, properties) {
        const menu = new Menu(title, properties);
        this.addChildBlock(menu);
        return menu;
    }

    powerSliderPopup(title, properties) {
        const powerSliderPopup = new PowerSliderPopup(title, properties);
        this.addChildBlock(powerSliderPopup);
        return powerSliderPopup;
    }

    range(title, properties) {
        let range = new Builder.blockTypes['Range'](title, properties);
        this.addChildBlock(range);
        return range;
    }

    readOnlyFor(role) {
        let readOnlyFor = new ReadOnlyFor(role);
        this.addChildBlock(readOnlyFor, 'securityModifier');
        return this;
    }

    shortTextView(title, properties) {
        let shortTextView = new ShortTextView(title, properties);
        this.addChildBlock(shortTextView);
        return shortTextView;
    }

    subForm(title, properties) {
        const subForm = new SubForm(title, properties);
        this.addChildBlock(subForm);
        return subForm;
    }

    swagger(title, properties) {
        let swagger = new Swagger(title, properties);
        this.addChildBlock(swagger);
        return swagger;
    }

    tableList(title, properties) {
        let list = new TableList(title, properties);
        this.addChildBlock(list);
        return list;
    }

    toggle(title, properties) {
        let actionElement = new Toggle(title, properties);
        this.addChildBlock(actionElement);
        return this;
    }

    menuButton(title, properties) {
        let actionElement = new MenuButton(title, properties);
        this.addChildBlock(actionElement);
        return actionElement;
    }

    paragraph(title, properties) {
        let child = new FixedText(title, properties);
        this.addChildBlock(child);
        return this;
    }
};
